import React, {useContext, useState} from 'react';
import ResultsTableContainer from "./ResultsTable/ResultsTableContainer";
import Button from "../Components/Button";
import RatesSearchForm from './RatesSearchForm/RatesSearchForm';
import FilterContainers from './RateSearchFilters/FiltersContainer';
import resultsContext from '../Foundations/Contexts/ResultsContext';
import searchFilterContext from '../Foundations/Contexts/SearchFilterContext';
import PriceSummaryContainer from "./PriceSummary/PriceSummaryContainer";
import ExportReportModal from "../Components/Modals/ExportReportModal";
import {MAX_ALLOWED_RESULT} from '../Foundations/Constants/ReportConfig';
import WarningModal from '../Components/Modals/WarningModal';
import NoResultMessage from '../Components/NoResultMessage/NoResultMessage';

const ResultsPageContainer: React.FC = () => {
    const {results} = useContext(resultsContext);
    const {searchParameters} = useContext(searchFilterContext);
    const [showExportModal, setShowExportModal] = useState<boolean>(false);

    const toggleShowExportModal = () => {
        setShowExportModal(!showExportModal)
    }

    return (
        <div>
            <div className="flex justify-between items-center mb-8">
                <div className="flex flex-col">
                    <span className="text-2xl font-bold text-gray-900 mb-1">Search results</span>
                    <span className="text-base text-gray-600">{`${results ? results.length : ''} results`}</span>
                </div>
                <Button text="Export report" onClick={toggleShowExportModal}/>
            </div>
            <div className="bg-blue-600 rounded-2xl px-5 py-5 mb-2">
                {
                    searchParameters !== null &&
                    <RatesSearchForm
                        lat={searchParameters.latitude}
                        lng={searchParameters.longitude}
                        initialDate={new Date(searchParameters.date)}
                        className="mb-0"
                    />
                }
            </div>
            {
                results.length > 0 && <PriceSummaryContainer />
            }
            {
                searchParameters !== null &&
                <div className="mb-5">
                    <FilterContainers />
                </div>
            }
            {
                results.length > 0 &&
                <ResultsTableContainer />
            }
            {
                results.length === 0 && (
                   <NoResultMessage />
                )
            }
            {
                showExportModal &&
                results.length <= MAX_ALLOWED_RESULT &&
                results.length > 0 &&
                <ExportReportModal hide={toggleShowExportModal}/>
            }
            {
                showExportModal &&
                (results.length > MAX_ALLOWED_RESULT || results.length === 0) &&
                <WarningModal
                    hide={toggleShowExportModal}
                    content={results.length > MAX_ALLOWED_RESULT
                        ? 'Filter your results to get a more specific report.'
                        : 'Cannot export empty result.'
                    }
                    header={
                        results.length > MAX_ALLOWED_RESULT
                            ? 'You cannot export more than 1,000 results'
                            : 'No results found.'
                    }
                />
            }
        </div>
    )
};

export default ResultsPageContainer;
